import React from 'react';
import {
  Body,
  designSystemToken,
  Headline,
} from '@lightricks/react-design-system';
import {
  DEFAULT_UPLOAD_LIMITS,
  getUploadLimits,
} from '@contentlab/config/uploadLimits';
import translate from '@/utils/translate';
import FileUploaderButton from '@/views/content-studio/components/file-upload/FileUploaderButton';
import styles from './EmptyAssetsState.module.scss';

function EmptyAssetsState({featureName}: {featureName?: string}) {
  return (
    <div className={styles.emptyStateContainer}>
      <img
        src="https://storage.googleapis.com/brands-public-assets/content-lab/EmptyAssets.svg"
        alt=""
      />
      <Headline size="lg">{translate('No Videos Yet')}</Headline>
      <Body
        size="lg"
        marginBottom="24px"
        color={designSystemToken('semantic.fg.secondary')}
      >
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: featureName
              ? translate('upload_speech_video_to_feature', {
                  featureName: featureName?.toLowerCase(),
                  maxDuration:
                    getUploadLimits(featureName).maxDurationDisplayKey,
                })
              : translate('upload_speech_video_to_ltx_scaler', {
                  maxDuration: DEFAULT_UPLOAD_LIMITS.maxDurationDisplayKey,
                }),
          }}
        />
      </Body>
      <FileUploaderButton
        buttonLabel={translate('Upload Videos')}
        mode="filled"
        size="large"
        iconAppearance="neutral-secondary"
        iconSize="medium"
      />
    </div>
  );
}

export default EmptyAssetsState;
